import React, { useRef } from "react";

/**
 * SpotlightCard — wraps content with a mouse-following radial spotlight.
 * Uses CSS variables --x and --y updated via mousemove for performance.
 */
export const SpotlightCard = ({ as = "div", className = "", glowColor = "rgba(123,47,190,0.18)", children, ...rest }) => {
  const ref = useRef(null);
  const Tag = as;

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--sx", `${e.clientX - rect.left}px`);
    el.style.setProperty("--sy", `${e.clientY - rect.top}px`);
  };

  return (
    <Tag
      ref={ref}
      onMouseMove={onMove}
      data-spotlight=""
      className={`relative overflow-hidden ${className}`}
      style={{
        // expose glow color
        ["--spot-color"]: glowColor,
      }}
      {...rest}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100 hover:opacity-100"
        style={{
          background: "radial-gradient(360px circle at var(--sx, 50%) var(--sy, 50%), var(--spot-color), transparent 60%)",
        }}
        aria-hidden
      />
      {children}
    </Tag>
  );
};

export default SpotlightCard;
